import {Display} from "./Display";
import {History} from "./History";
import {Basic} from "./Basic";
import {Podcastplayer} from "./Podcastplayer";
import {Load} from "./Load";
import {Form} from "./Form";

export class Lightbox
{
    constructor(startElement, load)
    {
        Lightbox.close();

        this.mode = startElement.dataset.action;
        this.images = [];
        this.videos = [];
        this.activeMediaNo = 0;
        this.remLocation = '';

        if(!load && (startElement.dataset.url || startElement.href))
        {
            this.remLocation = document.location.pathname;
            const url = startElement.dataset.url ? startElement.dataset.url : startElement.href;
            History.push_url(url,true);
        }
        else if(load === true)
        {
            this.remLocation = document.location.pathname.replace(/^(.*\/)[-_\da-z]+$/,'$1');
        }

        switch(this.mode)
        {
            case 'download': this.set_downloadMode(startElement); break;
            case 'gallery': this.set_galleryMode(startElement); break;
            case 'newsletter': this.set_newsletterMode(); break;
            case 'video': this.set_videoMode(startElement, load); break;
            default: return false;
        }
    }

    set_downloadMode(el)
    {
        this.build_lightboxContainer();

        this.lightboxContainer.classList.add('mod--prompt');

        const promptDiv = document.createElement('div');
        promptDiv.classList.add('w__lightbox--prompt');
        this.lightboxContainer.appendChild(promptDiv);

        const promptTitle = document.createElement('h2');
        promptTitle.classList.add('w__lightbox--prompt-title');
        promptTitle.textContent = el.dataset.promptTitle;
        promptDiv.appendChild(promptTitle);

        const promptText = document.createElement('p');
        promptText.textContent = el.title;
        promptDiv.appendChild(promptText);

        const promptForm = document.createElement('form');
        promptForm.classList.add('w__lightbox--form');
        promptForm.setAttribute('method','post');
        promptDiv.appendChild(promptForm);

        let promptP = document.createElement('p');
        promptP.classList.add('w__input--container');
        promptForm.appendChild(promptP)

        const promptLabel = document.createElement('label');
        promptLabel.classList.add('w__input--label');
        promptLabel.textContent = el.dataset.promptLabel + ':';
        promptLabel.setAttribute('for','w--form-prompt-input');
        promptP.appendChild(promptLabel);

        const promptInput = document.createElement('input');
        promptInput.type = 'password';
        promptInput.id = "w--form-prompt-input";
        promptInput.classList.add('w__input');
        promptInput.classList.add('w__input--text');
        promptP.appendChild(promptInput);

        promptP = document.createElement('p');
        promptP.classList.add('w__form--submit');
        promptForm.appendChild(promptP);

        const promptSubmit = document.createElement('button');
        promptSubmit.innerHTML = '<span class="w__500">⟶</span> ' + el.dataset.promptSubmit;
        promptSubmit.classList.add('w__button');
        promptSubmit.classList.add('w__button--submit');
        promptSubmit.classList.add('w__hover--color-bg');
        promptSubmit.classList.add('mod--white');
        promptP.appendChild(promptSubmit);

        // set focus
        promptInput.focus();

        // submit event
        promptForm.addEventListener('submit',e =>
        {
            e.preventDefault();
            if(promptInput.value.trim())
            {
                Load.post({
                    f: 'protected-download',
                    pw: promptInput.value.trim(),
                    downloadId: el.dataset.downloadId
                }).then(r =>
                {
                    if(r.ok === true)
                    {
                        document.location = Basic.base + 'download.php?itemId=' +
                                            el.dataset.downloadId + '&lang=' + Basic.lang;
                        Lightbox.close();
                    }
                    else
                    {
                        if(!promptForm.querySelector('.w__lightbox--error'))
                        {
                            const promptError = document.createElement('p');
                            promptError.textContent = r['html'];
                            promptError.classList.add('w__lightbox--error');
                            promptForm.appendChild(promptError);
                        }
                    }
                }).catch(e =>
                {
                    console.log(e)
                });
            }
        });
    }

    set_galleryMode(startElement)
    {
        const firstImage = startElement.querySelector('.mod--lightbox');

        // set container in which to search for images
        let parentEl;
        if(startElement.classList.contains('w__tile'))
        {
            parentEl = startElement;
        }
        else if(startElement.closest('.w__tile'))
        {
            parentEl = startElement.closest('.w__tile');
        }
        else
        {
            parentEl = document.getElementById('w--main');
        }

        // get all images in container
        this.images = parentEl.querySelectorAll('.mod--lightbox');

        if(this.images.length > 0)
        {
            for(let i=0; i<this.images.length; i++)
            {
                if(this.images[i] === firstImage)
                {
                    this.activeMediaNo = i
                }
            }
            this.build_lightbox((this.images.length > 1));
            this.load_image();
        }
    }

    set_newsletterMode()
    {
        Load.post({
            f: 'form',
            action: 'build',
            formId: 11
        }).then(r => {
            this.build_lightboxContainer();
            this.lightboxContainer.classList.add('mod--prompt');
            const promptDiv = document.createElement('div');
            promptDiv.classList.add('w__lightbox--prompt');
            promptDiv.innerHTML = r['html'];
            this.lightboxContainer.appendChild(promptDiv);
            promptDiv.querySelector('.w__input--text').focus();
            new Form(promptDiv.querySelector('form'));
        }).catch(error => {
            console.error(error);
        });
    }

    set_videoMode(startVideo, load)
    {
        // stop all other audio
        Podcastplayer.stop_allPlayers();

        // called by URL, no autostart
        if(load === true)
        {
            // build lightbox
            this.build_lightbox();
            const videoPreview = startVideo.cloneNode(true);
            this.mediaContainer.appendChild(videoPreview);
        }
        else
        {
            // get all videos in container
            const videoContainer = startVideo.closest('.w__video--container,.w__tile--image-container,.w__header--video-figure');
            if(videoContainer)
            {
                this.videos = videoContainer.querySelectorAll('.w__tile--video-image');
            }

            // build lightbox, optinally with nav
            this.build_lightbox((this.videos.length > 1));
            Lightbox.build_video(this.mediaContainer, startVideo,1);
        }
        if(this.videos.length > 1)
        {
            this.mediaCounter.textContent = (this.activeMediaNo + 1).toString() + ' / ' +
                                            this.videos.length.toString();
        }
        this.mediaLegend.textContent = startVideo.dataset.legend;
        this.mediaCredit.textContent = startVideo.dataset.credit;
    }

    build_lightboxContainer()
    {
        this.lightboxContainer = document.createElement('div');
        this.lightboxContainer.classList.add('w__lightbox');
        this.lightboxContainer.id = 'w--lightbox';

        const closeButtonContainer = document.createElement('button');
        closeButtonContainer.classList.add('w__button');
        closeButtonContainer.classList.add('w__lightbox--close');
        closeButtonContainer.classList.add('w__blur--button');
        closeButtonContainer.classList.add('w__js-button');
        closeButtonContainer.dataset.f = 'lightbox-close';
        closeButtonContainer.dataset.url = this.remLocation;
        closeButtonContainer.dataset.mode = this.mode;

        const closeButton = document.createElement('span');
        closeButton.classList.add('w__item--close-x');
        closeButton.classList.add('mod--white');

        this.lightboxContainer.appendChild(closeButtonContainer);
        closeButtonContainer.appendChild(closeButton);

        // append lightbox to body
        document.body.appendChild(this.lightboxContainer);
    }


    build_lightbox(buildNav)
    {
        this.build_lightboxContainer();

        const lightboxInner = document.createElement('div');
        lightboxInner.classList.add('w__lightbox--inner');

        if(buildNav === true)
        {
            const navPrev = document.createElement('button');
            navPrev.classList.add('w__button');
            navPrev.classList.add('w__lightbox--nav');
            navPrev.classList.add('mod--prev');

            const navNext = document.createElement('button');
            navNext.classList.add('w__button');
            navNext.classList.add('w__lightbox--nav');
            navNext.classList.add('mod--next');

            const arrowPrev = document.createElement('span');
            arrowPrev.textContent = '⟶';
            arrowPrev.classList.add('w__blur--button');

            const arrowNext = document.createElement('span');
            arrowNext.textContent = '⟶';
            arrowNext.classList.add('w__blur--button');

            navPrev.appendChild(arrowPrev);
            navNext.appendChild(arrowNext);

            lightboxInner.appendChild(navPrev);
            lightboxInner.appendChild(navNext);
        }

        this.mediaContainer = document.createElement('div');
        this.mediaContainer.classList.add('w__lightbox--image-container');

        const lightboxContext = document.createElement('div');
        lightboxContext.classList.add('w__lightbox--context');

        this.mediaLegend = document.createElement('div');
        this.mediaLegend.classList.add('w__lightbox--legend');

        this.mediaCounter = document.createElement('div');
        this.mediaCounter.classList.add('w__lightbox--counter');

        this.mediaCredit = document.createElement('div');
        this.mediaCredit.classList.add('w__lightbox--credit');

        // put lightbox together
        this.lightboxContainer.appendChild(lightboxInner);

        lightboxInner.appendChild(this.mediaContainer);
        lightboxInner.appendChild(lightboxContext);

        lightboxContext.appendChild(this.mediaLegend);
        lightboxContext.appendChild(this.mediaCounter);
        lightboxContext.appendChild(this.mediaCredit);

        // activate navigation
        if(this.images.length > 1 ||
           this.videos.length > 1)
        {
            this.lightboxContainer.classList.add('mod--nav');
        }

        // add nav events
        this.add_events();
    }

    add_events()
    {
        this.lightboxContainer.addEventListener('click',e => {
            const el = e.target;
            if(el.classList.contains('w__lightbox--nav'))
            {
                const direction = el.classList.contains('mod--prev') ? 'prev' : "next";

                if(this.images.length)
                {
                    this.change_image(direction);
                }
                else if(this.videos.length)
                {
                    this.change_video(direction);
                }
            }
        });
    }

    change_image(direction)
    {
        if(direction === 'prev')
        {
            this.activeMediaNo--;
            if(this.activeMediaNo < 0)
            {
                this.activeMediaNo = this.images.length - 1;
            }
        }
        else
        {
            this.activeMediaNo++;
            if(this.activeMediaNo === this.images.length)
            {
                this.activeMediaNo = 0;
            }
        }

        this.load_image();
    }

    change_video(direction)
    {
        if(direction === 'prev')
        {
            this.activeMediaNo--;
            if(this.activeMediaNo < 0)
            {
                this.activeMediaNo = this.videos.length - 1;
            }
        }
        else
        {
            this.activeMediaNo++;
            if(this.activeMediaNo === this.videos.length)
            {
                this.activeMediaNo = 0;
            }
        }

        this.mediaLegend.textContent = this.videos[this.activeMediaNo].dataset.legend;
        this.mediaCredit.textContent = this.videos[this.activeMediaNo].dataset.credit;
        this.mediaCounter.textContent = (this.activeMediaNo + 1).toString() + ' / ' +
                                        this.videos.length.toString();
        History.push_url(this.videos[this.activeMediaNo].href);
        Lightbox.build_video(this.mediaContainer, this.videos[this.activeMediaNo],1);
    }

    load_image()
    {
        const el = this.images[this.activeMediaNo],
              src = this.adjust_imagePath(el.href ? el.href : el.src, el.dataset.width, el.dataset.height),
              myImage = new Image;
        myImage.classList.add('w__lightbox--image');
        myImage.src = src;
        myImage.alt = '';
        myImage.addEventListener('load',() =>
        {
            this.mediaCounter.textContent = (this.activeMediaNo + 1).toString() + ' / ' +
                                            this.images.length.toString();
            this.mediaContainer.innerHTML = '';
            this.mediaContainer.appendChild(myImage);

            this.mediaLegend.textContent = el.dataset.legend;
            this.mediaCredit.textContent = el.title;
        });
    }

    adjust_imagePath(imgSrc, maxX, maxY)
    {
        const filename = imgSrc.replace(/.*\//, '');

        // check aspect ratio of image against aspect ratio of media container,
        // select path based on tighter fit
        const sizeX = this.mediaContainer.getBoundingClientRect()['width'] * Display.dpi,
              sizeY = this.mediaContainer.getBoundingClientRect()['height'] * Display.dpi;
        let targetPath;

        // fit width
        if(maxX / maxY > sizeX / sizeY)
        {
            if(maxX / 4 >= sizeX)
            {
                targetPath = 'p25';
            }
            else if(maxX / 2 >= sizeX)
            {
                targetPath = 'p50';
            }
            else if(maxX / 4 * 3 >= sizeX)
            {
                targetPath = 'p75';
            }
            else
            {
                targetPath = 'p100';
            }
        }
        // fit height
        else
        {
            if(maxY / 4 >= sizeY)
            {
                targetPath = 'p25';
            }
            else if(maxY / 2 >= sizeY)
            {
                targetPath = 'p50';
            }
            else if(maxY / 4 * 3 >= sizeY)
            {
                targetPath = 'p75';
            }
            else
            {
                targetPath = 'p100';
            }
        }

        return Basic.base + 'db/bild/std/' + targetPath + '/' + filename;
    }

    static close(el)
    {
        // restore url
        if(el)
        {
            if(el.dataset.url)
            {
                History.push_url(el.dataset.url, true);
            }

            if(el.dataset.mode === 'newsletter')
            {
                localStorage.setItem('hide-newsletter-form', '1')
            }
        }

        const lightbox = document.getElementById('w--lightbox');
        if(lightbox)
        {
            lightbox.remove();
        }
    }

    static build_video(container, videoEl, autoplay)
    {
        const iFrame = Lightbox.build_iFrame(Lightbox.get_iFrameSrc(videoEl, autoplay),'w__video--iframe');
        container.innerHTML = '';
        container.classList.add('w__video--container');
        container.appendChild(iFrame);
    }

    static build_iFrame(mySrc, myClass)
    {
        const myIframe = document.createElement('iframe');
        myIframe.src = mySrc;
        myIframe.classList.add(myClass);
        myIframe.frameborder = 0;
        myIframe.allowfullscreen = 1;
        myIframe.setAttribute('allow','autoplay; fullscreen');
        return myIframe;
    }

    static get_iFrameSrc(videoEl, autoplay)
    {
        let url = videoEl.href ? videoEl.href : videoEl.dataset.url;
        switch(videoEl.dataset.videoType)
        {
            case 'youtube':
                url = 'https://www.youtube-nocookie.com/embed/' +
                    videoEl.dataset.videoCode +
                    '?showinfo=0' +
                    '&controls=1' +
                    '&fs=1' +
                    '&rel=0' +
                    '&hl=' + Basic.lang +
                    '&autoplay=' + autoplay +
                    '&modestbranding=1' +
                    '&showsearch=0';
                break;

            case 'vimeo':
                url = 'https://player.vimeo.com/video/' + videoEl.dataset.videoCode +
                    '?autoplay=' + autoplay +
                    '&badge=0' +
                    '&byline=0' +
                    '&portrait=0' +
                    '&title=0' +
                    '&dnt=1';
                break;

            default:
                alert('Unknown video type');
        }
        return url;
    }
}